module.exports = __webpack_public_path__ + "img/25.problem_lightning.f22b0f23.svg";